import { Route } from "react-router-dom";
import AuthorizedRoute from "../../components/routing/authorized-route";
import { Roles } from "../../components/routing/utils";

import Substatuses from "./page.highorder";

const ProtectedSubstatuses = () => (
  <AuthorizedRoute requiredRoles={[Roles.ADMIN]} component={Substatuses} />
);

const substatusesRoute = (
  <Route path="/manage-statuses" element={<ProtectedSubstatuses />} />
);

export default substatusesRoute;
